<template>
	<div>
        <Select v-model="item.val1" placeholder="请选择" @on-change="judgeFn" filterable class="sel">
            <Option v-for="(item,index) in typeSel" :key="index" :value="item.hid">{{item.hname}}</Option>
        </Select>
        <Select v-model="item.ope" placeholder="请选择" @on-change="judgeFn" class="ope">
            <Option v-for="(item,index) in operator" :key="item" :value="item">{{item}}</Option>
        </Select>
        <Select v-model="item.val2" placeholder="请选择" @on-change="judgeFn" filterable class="sel">
            <Option v-for="(item,index) in typeSel" :key="index" :value="item.hid">{{item.hname}}</Option>
        </Select>
    </div>
</template>
<script>
	export default{
		props:['msg'],
		data(){
			return{
                item:{
                    val1:'',
                    ope:'',
                    val2:'',
                },
                operator:['>','<','=','>=','<='],
                typeSel:[],
            }
		},
        created(){
            this.getSetDataFn();
        },
		methods:{
            judgeFn(){
                if(this.item.val1 == '' || this.item.ope == '' || this.item.val2 == ''){
                    return false;
                }

                this.msg.textid = this.item.val1 + this.item.ope + this.item.val2;
            },
            getSetDataFn(){
                var _this=this;
                this.$http.get('/web/template/getHeadByTemid',{
                    params:{
                        temid:_this.$route.query.temid
                    }
                }).then(function(res){
                    if(res.success){
                        _this.typeSel=res.data
                    }else{
                        _this.$Notice.error({
                            title:'获取规则下拉',
                            desc:'获取下拉失败'
                        });
                    }
                }).catch(function(){
                    _this.$Notice({
                        title:'获取规则下拉',
                        desc:'获取规则下拉失败'
                    });
                });
            },
        }
	}
</script>
<style scoped>
    .sel{
        width:200px;
    }
    .ope{
        width:65px;
    }
</style>


// WEBPACK FOOTER //
// src/components/template/rule/one.vue